import React from "react";
import ButtonOrang from "./ButtonOrang";

export default function HeroContacto({ titulo, buttonText, img, svg, url }) {
  const urlApi = process.env.REACT_APP_STRAPI_URL;

  return (
    <section
      className="relative w-full h-[420px] md:h-[480px] flex items-center justify-center overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage: `url(${urlApi}${img})`,
        backgroundSize: "container",
      }}
    >
      <div className="container flex flex-col items-center gap-2 ">
        <div className="">
          <img
            src={`${urlApi}${svg}`}
            alt="Decorative SVG"
            className="w-full h-full  object-contain    relative"
          />
        </div>

        <div className="relative  w-full flex flex-col gap-2 items-center justify-center px-2">
          <h1 className="text-sidom-light text-2xl md:text-3xl lg:text-4xl font-extrabold text-center mb-6 drop-shadow-lg">
            {titulo}
          </h1>
          {buttonText && buttonText.trim() !== "" && (
            <ButtonOrang
              text={buttonText}
              onClick={() =>
                window.open(
                  url.startsWith("http") ? url : `https://${url}`,
                  "_blank"
                )
              }
            />
          )}
        </div>
      </div>
    </section>
  );
}
